<template>
  <div class="home-page play-again">
    <div class="error-msg play-again-wrap">
      <div class="facebook-share-inner animate-slidein left-block" v-if="clubName">
        <div class="status-image desktop-view">
          <img src="/static/images/regluvardar_crown_logo.png" alt="logo" />
        </div>
        <p class="desktop-view user-name" v-if="fullName">{{fullName}}</p>
        <h4 v-if="clubName">{{clubName}}</h4>
        <p>Þú stóðst þig vel fyrir klúbbinn. Hvetjum aðra til að gera það sama.</p>
        <div class="leader-board">
          <div class="club-info">
            <span v-if="clubImage" class="club-image"><img :src="clubImage" alt="club-image"></span>
            <span class="user-points" v-if="userTotalPoints">{{userTotalPoints}} stig</span>
            <!-- <div class="facebook">
              <button class="button share-btn" type="button" @click="sharePage">Deila</button>
            </div> -->
          </div>
          <div class="club-list" v-loading="showLoader">
            <div class="club-detail-inner">
              <table>
                <tr class="table-head">
                  <th>Klúbbur</th>
                  <th>Stig</th>
                  <th>Meðlimir</th>
                </tr>
                <tr v-for="(club,index) in clubList" :key="index">
                  <td>{{club.name}}</td>
                  <td>{{club.total_points}}</td>
                  <td>{{club.percentage}}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <button class="button play-btn" type="button" v-if="seeAllClubs" @click="getTopClubs">Loka</button>
        <button class="button play-btn" type="button" v-else @click="getallClubs">Sjá alla klúbba</button>
      </div>
      <div class="card-inner animate-slidein">
        <div class="status-image mobile-view">
          <img src="/static/images/regluvardar_crown_logo.png" alt="vordur logo" />
        </div>
        <p class="sub-text">Regluvörður</p>
        <h2><strong>Vel gert {{fullName}},</strong> þú ert réttmætur Regluvörður</h2>
        <p class="yellow-line"></p>
        <p class="content-wrap">
          Þú ert skrefinu nær  því að vinna stóra vinninginn. 
          Fylgstu með okkur á Facebook en þar drögum við
          út fjölda vinninga í allt sumar.
        </p>
        <div class="facebook space-btw">
          <button class="button" type="button" @click="makeReadyToReplay">Spila aftur</button>
          <button class="button left-space" @click="goToFreePlay">Æfingasvæðið</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* global gtag */
/* eslint no-undef: "error" */
import API from '@/shared/api'
export default {
  name: 'RegluvardarShare',
  data () {
    return {
      playAgain: false,
      clubSearch: [],
      filteredList: [],
      userTotalPoints: null,
      clubImage: null,
      fullName: null,
      clubName: null,
      showLoader: false,
      showFinal: false,
      clubList: null,
      seeAllClubs: false
    }
  },
  created () {
    this.getTopClubs()
    if (this.$data.globalData && this.$data.globalData.user && this.$data.globalData.user.user_total_points) {
      this.userTotalPoints = this.$data.globalData.user.user_total_points
    }
    if (this.$data.globalData.user) {
      this.fullName = this.$data.globalData.user.name
      if (this.$data.globalData.user.user_club) {
        this.clubImage = this.$data.globalData.user.user_club.image_url
        this.clubName = this.$data.globalData.user.user_club.name
      }
    }
  },
  methods: {
    getallClubs () {
      this.showLoader = true
      let self = this
      API.meInstance.get('/clubs/points/').then((res) => {
        this.clubList = res.data.clubs
        this.showLoader = false
        this.seeAllClubs = true
      }).catch((error) => {
        console.log('Error loading', error)
      })
    },
    getTopClubs () {
      let self = this
      API.meInstance.get('/clubs/').then((res) => {
        self.clubList = res.data.data
        this.seeAllClubs = false
      }).catch((error) => {
        console.log('Error loading', error)
      })
    },
    goToFreePlay () {
      this.$router.push({ path: '/frjals-spilun/', query: { name: 'fromSharePage'} })
    },
    golfGreeting() {
      this.showGolfProtection = true;
    },
    makeReadyToReplay () {
      this.showLoader = true
      API.meInstance.post('/user/replay/', { 'delete': true }).then((res) => {
        this.showLoader = false
        this.$message({
          type: 'Árangur',
          message: 'You can play again'
        });
        if (res.data.status) {
          window.location.href = '/spurningar/'
        }
      }).catch((error) => {
        console.log('Error loading', error)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.user-name {
  // margin-left: 10px;
}
.leader-board {
  padding-top: 30px;
  .user-points {
    font-size: 32px;
    line-height: 38px;
    color: #011627;
    display: inline-block;
    padding-left: 20px;
    font-weight: 600;
  }
  .club-image {
    display: inline-block;
    width: 75px;
  }
}
.home-page {
  // padding: 2rem 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100% - 100px);
  &.play-again {
    background: url(/static/images/regluvordur-bg.jpg);
    background-size: cover;
    background-repeat: no-repeat;
    height: calc(100% - 69px);
  }
  .medal-details {
    padding-top: 3rem;
    position: relative;
    max-width: 600px;
    margin: 0 auto;
    text-align: center;
  }
}
.status-image {
  img {
    width: 135px;
    height: 131px;
  }
}

.facebook-share-inner {
  padding-bottom: 10rem;
  &.left-block {
    background: #fff;
    // position: absolute;
    // top: 0;
    // bottom: 0;
    display: block;
    overflow-y: auto;
    height: 100%;
    padding: 40px 80px 20px 80px;
    text-align: left;
    max-width: 625px;
    position: relative;
    left: -625px;
    animation: slide .5s forwards;
    animation-delay: .1s;
    h4 {
      font-size: 32px;
      line-height: 38px;
      font-weight: 400;
      max-width: 430px;
      margin-top: 20px;
    }
    p {
      max-width: 340px;
    }
    .status-image {
      img {
        width: 95px;
        height: 86px;
      }
    }
    .button {
      &.share-btn {
        margin-top: 15px;
      }
      &.play-btn {
        margin-top: 50px;
      }
    }
  }
}
.error-msg {
  position: relative;
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
  padding: 0 5px;
  &.play-again-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-width: initial;
    height: 100%;
    padding: 0;
  }
}
.button {
  border-radius: 10px;
}

.space-btw {
  .button {
    margin-right: 1rem;
  }
  .left-space {
    margin-left: 1rem;
  }
}

.card-inner {
  // position: absolute;
  // top: 0;
  // right: 0;
  // margin: 100px 100px 0 0;
  margin: 0 10rem 0 10rem;
  max-width: 570px;
  text-align: left;
  img {
    width: 95px;
    height: 86px;
  }
  h2 {
    font-size: 48px;
  }
  strong {
    display: block;
  }
}
.club-list {
  padding-top: 20px;
  table {
    .table-head {
      th {
        font-size: 14px;
        line-height: 17px;
        color: #696865;
        padding: 10px 50px 10px 0;
      }
    }
    td {
      font-weight: 500;
      font-size: 20px;
      line-height: 168%;
      padding: 5px 45px 0px 0;
      &:nth-child(2) {
        color: #FCBD00;
      }
    }
  }
}
.club-detail-inner {
  .clubs {
    &:first-child {
      padding-left: 0;
    }
    &.members {
      .club-points {
        color: #696865;
      }
    }
  }
  h5 {
    margin-bottom: 30px;
  }
}
.club-list-inner {
  max-width: 284px;
	position: relative;
	font-size: 14px;
  text-align: left;
}
.club-points {
  color: #FCBD00;
}

@keyframes slide {
    100% { left: 0; }
}
@media (min-width: 1600px) {
  .card-inner {
    margin: 0 20rem 0 10rem;
  }
}
@media (max-width: 1300px) {
  .card-inner {
    min-height: 461px;
    h2 {
      font-size: 36px;
      line-height: 46px;
    }
  }
  .space-btw {
    .button {
      padding: 1.3rem 3.5rem;
    }
  }
}

@media (max-width: 1140px) {
  .card-inner {
    margin: 0px 55px 0 94px;
    min-height: 483px;
  }
  .space-btw {
    .button {
      font-size: 1.4rem;
    }
  }
//   .facebook-share-inner {
//     &.left-block {
//       max-width: 490px;
//       padding: 20px 40px;
//     }
//   }
//   .card-inner {
//     margin: 50px 20px 0 0;
//   }
}

@media (max-width: 991px) {
  .error-msg {
    &.play-again-wrap {
      background: #fff;
      display: flex;
    }
  }
  .facebook-share-inner {
    &.left-block {
      max-width: 490px;
      padding: 20px 40px;
      h4 {
        font-size: 24px;
        line-height: 30px;
      }
      p {
        font-size: 16px;
      }
    }
  }
  .club-list table td {
    font-size: 14px;
  }
  .card-inner {
    margin: 50px 20px 50px 0;
    position: initial;
    h2 {
      line-height: 32px;
      font-size: 26px;  
    }
  }
}
@media (max-width: 767px) {
  .error-msg {
    &.play-again-wrap {
      // display: block;
      flex-direction: column;
      padding-top: 70px !important;
      justify-content: initial;
    }
  }
  .facebook-share-inner {
    order: 2;
    padding-bottom: 1rem;
    &.left-block {
      max-width: 100%;
      overflow-y: initial;
      height: initial;
      left: 0;
      padding: 20px 10px;
    }
  }
  .club-list  {
    table {
      .table-head th {
        padding: 10px 23px 10px 0;
      }
      table td {
        padding: 5px 15px 0px 0;
      }
    }
  }
  .card-inner {
    max-width: 100%;
    min-height: inherit;
    box-shadow: none;
    margin: 0px 0px 0px 0;
    padding: 1.3rem;
  }
  .space-btw {
    .button {
      margin-left: 0;
    }
    a {
      width: 100%;
      text-align: center;
    }
  }
}

</style>
